import React from 'react';
import { FaMinus, FaTrash, FaDownload, FaExpand, FaCompress } from 'react-icons/fa';
import { useMike } from '../../../context/MikeContext';

/**
 * ChatHeader - Header component for the chat widget
 *
 * Shows Mike branding, minimize button, download button, and clear chat button
 */
const ChatHeader = ({ onMinimize, onClear, onMouseDown, isDragging }) => {
  const { downloadConversation, isExpanded, toggleExpanded } = useMike();
  return (
    <div
      onMouseDown={onMouseDown}
      style={{
        backgroundColor: '#0056b3',
        color: 'white',
        padding: '16px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: '12px 12px 0 0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        cursor: isDragging ? 'grabbing' : 'grab',
        userSelect: 'none'
      }}
    >
      {/* Left: Mike branding */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}>
          <img
            src="/icons/mike.png"
            alt="Mike"
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              objectFit: 'contain',
              objectPosition: 'center'
            }}
          />
        </div>
        <div>
          <div style={{ fontSize: '16px', fontWeight: '600', lineHeight: '1.2' }}>
            Mike
          </div>
          <div style={{ fontSize: '11px', opacity: 0.9, lineHeight: '1.2' }}>
            DST Specialist
          </div>
        </div>
      </div>

      {/* Right: Action buttons */}
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        {/* Download conversation button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            downloadConversation();
          }}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.8,
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}
          title="Download conversation"
        >
          <FaDownload size={14} />
        </button>

        {/* Clear chat button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (window.confirm('Clear all messages? This will reset the conversation and show a new welcome message.')) {
              onClear();
            }
          }}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.8,
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}
          title="Clear chat"
        >
          <FaTrash size={14} />
        </button>

        {/* Expand/Collapse button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleExpanded();
          }}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.8,
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}
          title={isExpanded ? 'Collapse' : 'Expand'}
        >
          {isExpanded ? <FaCompress size={14} /> : <FaExpand size={14} />}
        </button>

        {/* Minimize button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onMinimize();
          }}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.8,
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}
          title="Minimize"
        >
          <FaMinus size={18} />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
